import { Injectable } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/storage';

@Injectable({
  providedIn: 'root',
})
export class FirebaseStorageService {

  private path = '';

  constructor(
    private storage: AngularFireStorage,
  ) { }

  taskCloudStorage(filename: string, data: any) {
    return this.storage.upload(`${this.path}/${filename}`, data);
  }

  referenceCloudStorage(filename: string) {
    return this.storage.ref(`${this.path}/${filename}`);
  }

  setPath(path: string) {
    this.path = path;
  }

  getPath() {
    return this.path;
  }

}
